import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Button, Thumbnail, Col, Row, Panel } from 'react-bootstrap';
import _ from 'lodash'

import { } from '../actions'
import NavHeader from './navheader'
import SubMenu from './submenu'
import SearchPage from './search_page'
import CarouselComponent from './carousel'
import TopCarouselComponent from './top_carousel'
import ProductItem from './product_item'
import ShowCategory from './showcategory'
import Product from './product'
import CarouselCategories from './carousel_categories'
import Footer from './footer'
import Slider from 'react-slick'
import CategoryItemlong from './category_itemlong'
import MetaTags from 'react-meta-tags'
import BlogComponent from './blogComponent'

function PrevArrow(props) {
  const { className, style, onClick } = props
  return (
    <image className={className} onClick={onClick} style={{ width: 35, height: 35 }} src='../../static/images/carouselArrow/backward.png' />
  )
}
function NextArrow(props) {
  const { className, style, onClick } = props
  return (
    <image className={className} onClick={onClick} style={{ width: 35, height: 35 }} src='../../static/images/carouselArrow/forward.png' />
  )
}

class Home extends Component {

  componentDidMount() {
    window.scrollTo(0, 0)
  }

  // renderSuggestProduct() {
  //   let id = 1
  //   return _.map(this.props.suggest_products.products_suggest, product => {
  //     if (product.visible) {
  //       return (
  //         <ProductItem key={id++} product={product} history={this.props.history} />
  //       )
  //     }
  //   })
  // }

  // renderSuggestProductNew(products) {
  //   console.log(1);
  //   let id = 0
  //   let listSiteShow = []
  //   let prevProduct = 'nothave'
  //   _.map(products, product => {
  //     if (product.visible) {
  //       if (prevProduct == 'nothave') {
  //         prevProduct = product
  //       } else {
  //         listSiteShow.push(<div key={id++} style={{ padding: 7 }}><ProductItem isCarousel={false} product={prevProduct} history={this.props.history} /><ProductItem isCarousel={true} product={product} history={this.props.history} /></div>)
  //         prevProduct = 'nothave'
  //       }
  //     }
  //   })

  // if (!_.isEmpty(products)) {
  //   console.log(2);
  //       // _.map(listSiteShow, list => {
  //       return <div>{listSiteShow[0]}</div>
  //       // })
  // } else {
  //   console.log(3)
  //   return <div></div>
  // }
  // }

  renderSuggestProduct(products, slidesToShow) {
    var setting = {
      responsive: [
        {
          breakpoint: 767, settings: {
            dots: false,
            infinite: true,
            speed: 500,
            slidesToShow: 2,
            slidesToScroll: 2,
            autoplay: true,
            autoplaySpeed: 5000,
            swipeToSlide: true,
            prevArrow: <PrevArrow />,
            nextArrow: <NextArrow />,
          }
        },
        {
          breakpoint: 991, settings: {
            dots: false,
            infinite: true,
            speed: 500,
            slidesToShow: slidesToShow,
            slidesToScroll: 4,
            autoplay: true,
            autoplaySpeed: 5000,
            swipeToSlide: true,
            prevArrow: <PrevArrow />,
            nextArrow: <NextArrow />,
          }
        },
        {
          breakpoint: 2599, settings: {
            dots: false,
            infinite: true,
            speed: 500,
            slidesToShow: slidesToShow,
            slidesToScroll: 4,
            autoplay: true,
            autoplaySpeed: 5000,
            swipeToSlide: true,
            prevArrow: <PrevArrow />,
            nextArrow: <NextArrow />,
          }
        }
      ]
    }
    let id = 0
    let listSiteShow = []
    let prevProduct = 'nothave'
    _.map(products, product => {
      if (product.visible) {
        if (prevProduct == 'nothave') {
          prevProduct = product
        } else {
          listSiteShow.push(<div key={id++} style={{ padding: 7 }}><ProductItem isCarousel={true} product={prevProduct} history={this.props.history} /><ProductItem isCarousel={true} product={product} history={this.props.history} /></div>)
          prevProduct = 'nothave'
        }
      }
    })

    if (!_.isEmpty(products)) {
      return (
        <div>
          <Slider {...setting}>
            {listSiteShow}
          </Slider>
        </div>
      )
    } else {
      return <div></div>
    }
  }

  renderPromotionProduct() {
    let id = 1
    return _.map(this.props.promotion_products.products_promotion, product => {
      if (product.visible) {
        return (
          <ProductItem key={id++} product={product} history={this.props.history} />
        )
      }
    })
  }

  renderCarouselEvent(products, slidesToShow) {
    var setting = {
      responsive: [
        {
          breakpoint: 767, settings: {
            dots: false,
            infinite: true,
            speed: 500,
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: false,
            autoplaySpeed: 5000,
            swipeToSlide: true,
            prevArrow: <PrevArrow />,
            nextArrow: <NextArrow />,
          }
        },
        {
          breakpoint: 991, settings: {
            dots: false,
            infinite: true,
            speed: 500,
            slidesToShow: slidesToShow,
            slidesToScroll: 1,
            autoplay: false,
            autoplaySpeed: 5000,
            swipeToSlide: true,
            prevArrow: <PrevArrow />,
            nextArrow: <NextArrow />,
          }
        },
        {
          breakpoint: 2599, settings: {
            dots: false,
            infinite: true,
            speed: 500,
            slidesToShow: slidesToShow,
            slidesToScroll: 1,
            autoplay: false,
            autoplaySpeed: 5000,
            swipeToSlide: true,
            prevArrow: <PrevArrow />,
            nextArrow: <NextArrow />,
          }
        }
      ]
    }
    let id = 0
    let listSiteShow = []
    _.map(products, product => {
      listSiteShow.push(<div key={id++} style={{ padding: 7 }}><ProductItem event isCarousel={true} product={product} history={this.props.history} /></div>)
    })

    if (!_.isEmpty(products)) {
      return (
        <div>
          <Slider {...setting}>
            {listSiteShow}
          </Slider>
        </div>
      )
    } else {
      return <div></div>
    }
  }

  renderBlogList(bloglist, slidesToShow) {
    var setting = {
      responsive: [
        {
          breakpoint: 767, settings: {
            dots: false,
            infinite: true,
            speed: 500,
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: false,
            autoplaySpeed: 5000,
            swipeToSlide: true,
            prevArrow: <PrevArrow />,
            nextArrow: <NextArrow />,
          }
        },
        {
          breakpoint: 991, settings: {
            dots: false,
            infinite: true,
            speed: 500,
            slidesToShow: slidesToShow,
            slidesToScroll: 1,
            autoplay: false,
            autoplaySpeed: 5000,
            swipeToSlide: true,
            prevArrow: <PrevArrow />,
            nextArrow: <NextArrow />,
          }
        },
        {
          breakpoint: 2599, settings: {
            dots: false,
            infinite: true,
            speed: 500,
            slidesToShow: slidesToShow,
            slidesToScroll: 1,
            autoplay: false,
            autoplaySpeed: 5000,
            swipeToSlide: true,
            prevArrow: <PrevArrow />,
            nextArrow: <NextArrow />,
          }
        }
      ]
    }
    let id = 0
    let listSiteShow = []
    _.map(bloglist, blog => {
      listSiteShow.push(<div key={id++} style={{ padding: 7 }}><BlogComponent blog={blog} /></div>)
    })

    if (!_.isEmpty(bloglist)) {
      return (
        <div>
          <Slider {...setting}>
            {listSiteShow}
          </Slider>
        </div>
      )
    } else {
      return <div></div>
    }
  }

  renderHomepage() {
    // !_.isEmpty(this.props.suggest_products) && !_.isEmpty(this.props.promotion_products) ? console.log('metatags') : ''
    return (
      <div>
        <NavHeader history={this.props.history} id={undefined} />
        <SubMenu ref={d => this.submenu = d} history={this.props.history} />
        <div className="container main-bg">
          {
            !_.isEmpty(this.props.suggest_products) && !_.isEmpty(this.props.promotion_products)
              ? <MetaTags>
                <title>{'ส่งสด - บริการส่งของสดจากตลาด'}</title>
                <meta property="og:title" content={'ส่งสด บริการส่งของสด'} />
                <meta property="og:url" content={window.location.href} />
                <meta property="og:image" content='https://songsod.com/android-icon-192x192.png' />
                <meta property="og:description" content={'บริการส่งของสดจาก ตลาดยิ่งเจริญ ที่คัดสรรคุณภาพของวัตถุดิบโดยผู้ซื้อสินค้าส่วนตัว'} />
                <meta property="og:type" content='website' />
                <meta property="fb:pages" content="129193147647837" />
              </MetaTags> : ''
          }
          <div className="container">
            <div>
              <Row>
                <TopCarouselComponent history={this.props.history} />
              </Row>
            </div>
            {/* <div style={{
              padding: 20,
              fontSize: 20,
              textAlign: 'center',
              cursor: 'pointer',
            }} className='how-to-pre-order'
            onClick={()=>{
              window.open('/blog/chinese-new-year-preorder-howto')
            }}
            >วิธีการสั่งล่วงหน้า โปรโมชั่นตรุษจีน
              <span style={{
                fontSize: 22,
                fontWeight: 'bold',
                verticalAlign: 'bottom',
              }}>คลิ้ก!</span>
            </div> */}


            {/* ช่องโปร */}

            {
              // <div className='event'>
              //   <Panel className='hidden-xs' style={{ backgroundColor: '#C11F1F', width: '100%' }}>
              //     <Col md={3} sm={3}>
              //       <h4 style={{ color: 'white', textAlign: 'center', paddingBottom: 0, paddingTop: 150 }}>ตรุษจีนจัดเต็ม</h4>
              //       {/* <h4 style={{ color: 'white', textAlign: 'center', paddingBottom: 20, paddingTop: 20 }}>ด้วยสงกรานต์เซทไปด้วยกัน</h4> */}
              //       <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              //         <button className='btn btn-primary event-btn' onClick={() => { this.props.history.push('/search/สินค้าตรุษจีน') }}>ดูสินค้าตรุษจีนทั้งหมด</button>
              //       </div>
              //   </Col>
              //     <Col md={9} sm={9}>
              //       {this.renderCarouselEvent(this.props.event_products.event_products, 3)}
              //     </Col>
              //   </Panel>
              //   <Panel className='hidden-sm hidden-md hidden-lg' style={{ backgroundColor: '#C11F1F', width: '100%' }}>
              //     <h4 style={{ color: 'white', textAlign: 'center', paddingBottom: 0, paddingTop: 20 }}>ตรุษจีนจัดเต็ม</h4>
              //     {/* <h4 style={{ color: 'white', textAlign: 'center', paddingBottom: 20, paddingTop: 20 }}>ด้วยสงกรานต์เซทไปด้วยกัน</h4> */}
              //     <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              //       <button style={{ textAlign: 'center' }} className='btn btn-primary event-btn' onClick={() => { this.props.history.push('/search/สินค้าตรุษจีน') }}>ดูสินค้าตรุษจีนทั้งหมด</button>
              //     </div>
              //     {this.renderCarouselEvent(this.props.event_products.event_products, 3)}
              //   </Panel>
              // </div>
            }

            {/* <Panel style={{ backgroundColor: '#233268', width: '100%' }}>
              <h3 style={{ color: 'white', textAlign: 'center', paddingBottom: 20, paddingTop: 20 }}>ชุดพิเศษ ตรุษจีน</h3>
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom:10 }}>
                <button style={{ textAlign: 'center' }} className='btn btn-primary' onClick={() => { this.props.history.push('/search/ชุดตรุษจีน') }}>ดูสินค้าชุดตรุษจีนทั้งหมด</button>
              </div>
              {this.renderCarouselEvent(this.props.event_products2.event_products, 4)}
            </Panel> */}

          </div>
          <div className="container">
            <div>
              <Row>
                <div><h4 className="header-homepage-product">สินค้าแนะนำ</h4></div>
                <div className="row row-product-item">{this.renderSuggestProduct(this.props.suggest_products.products_suggest, 4)}</div>
              </Row>
              <Row>
                <div className="header-product-home" style={{ paddingBottom: 0 }}><h3 style={{ textAlign: 'center' }}>หมวดหมู่สินค้า</h3></div>
                <br />
                <div>
                  <CarouselCategories history={this.props.history} />
                </div>
                <br />
                <div className="header-product-home" style={{ paddingTop: 0 }}>
                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <button className='btn btn-add-to-cart' style={{ fontSize: 16, width: 200, color: 'white' }}
                      onClick={() => { this.props.history.push('/search/categories'); window.fbq('trackCustom', 'ViewAll-2'); }}>ดูสินค้าทั้งหมด</button>
                  </div>
                </div>
              </Row>
              {/* <Row>
                <div><h4 className="header-homepage-product">สินค้าโปรโมชั่น</h4></div>
                <div className="row ow-product-item">{this.renderPromotionProduct()}</div>
              </Row>
              <hr /> */}
              <Row>
                <h4 className="header-homepage-product">บทความ</h4>
                {this.renderBlogList(this.props.suggestBlogs, 3)}
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <button className='btn btn-primary' onClick={() => { this.props.history.push('/blog/all') }}>ดูบทความทั้งหมด</button>
                </div>
              </Row>
              <hr />
              <Row>
                <div style={{ textAlign: 'center' }}>
                  <h3>ส่งสดทำงานอย่างไร ?</h3>
                </div>
                <img src="../../static/images/progress.jpg" style={{ width: '100%' }} />
              </Row>
              {/* <div><ShowCategory history={this.props.history} /></div> */}
            </div>
          </div>
        </div>
      </div >
    )
  }

  renderProduct() {
    return (
      <div>
        <NavHeader history={this.props.history} id={this.props.match.params.productid} />
        <SubMenu ref={d => this.submenu = d} history={this.props.history} />
        <Product history={this.props.history} id={this.props.match.params.productid} />
      </div>
    )
  }

  renderSearchPage() {
    return (
      <div>
        <NavHeader history={this.props.history} id={this.props.match.params.searchid} />
        <SubMenu ref={d => this.submenu = d} history={this.props.history} />
        <SearchPage history={this.props.history} id={this.props.match.params.searchid} />
      </div>
    )
  }

  render() {
    // localStorage.removeItem('cart_products')
    return (
      <div className='homepage' style={{ textAlign: 'center' }}>
        {/* <img src="../../static/images/ma.jpg" style={{ width: '30%' }} /> */}
        {(this.props.match.params.searchid == undefined) && (this.props.match.params.productid == undefined) ? this.renderHomepage() :
          this.props.match.params.searchid != undefined ? this.renderSearchPage() :
            this.renderProduct()}
        <Footer ref={e => this.footer = e} history={this.props.history} />
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    products: state.products,
    suggest_products: state.suggest_products,
    promotion_products: state.promotion_products,
    suggestBlogs: state.blogsReducer,
    // event_products: state.event_products_reducer,
    // event_products2: state.event_products2_reducer,
  }
}

export default connect(mapStateToProps, {})(Home)



// WEBPACK FOOTER //
// ./src/components/home.js